import { useFleetLimitedAccess } from '@src/features/fleet/context/fleet-limited-access-context';
import { useDroneFirmware, useSelectedFleetDrone } from '@src/features/fleet/pages/drones-page/hooks';
import { useDroneFlightStats } from './use-drone-flight-stats';
import { useHubName } from './use-hub-name';

export function useOverviewPanel() {
  const fleetLimited = useFleetLimitedAccess();
  const { selectedDrone, droneId, hasDrone } = useSelectedFleetDrone();
  const hubName = useHubName(selectedDrone);
  const firmware = useDroneFirmware({
    droneId,
    enabled: hasDrone,
    canUpdate: !fleetLimited,
  });
  const flightStats = useDroneFlightStats(droneId, hasDrone);

  return {
    selectedDrone,
    hasDrone,
    hubName,
    flightStats,
    firmwareBannerView: firmware.bannerView,
    droneVersion: firmware.droneVersion,
    isFirmwareLoading: firmware.isLoading,
    handleFirmwareUpdate: firmware.handleFirmwareUpdate,
    isUpdating: firmware.isUpdating,
  };
}
